<template>
	<div class="w-100 my-5 py-4">
		<loader v-if="!not_found" />
		<div v-else class="mx-auto d-block text-center">
      <img src="../../../assets/img/icon/404.png" width="180" class="mb-4">
      <p class="mb-0 body-2-2 text-20 font-extrabold">{{$t("hotel.data-not-found")}}</p>
      <p class="mb-0 body-2-2 font-regular text-14">{{$t("hotel.You will be redirect to Booking Engine Page")}}</p>
    </div>
	</div>
</template>
<script>
	import {mapMutations} from 'vuex'
	import moment from 'moment'
	import {get} from '@/services/index.js';

	export default{
		metaInfo(){
      return {title:'Loading...'}
    },
		data(){
			return{
				not_found: false
			}
		},
		mounted(){
			this.setupData()
		},
		methods:{
			...mapMutations(['resetBeFilter','resetBECart','setBeFilterDetail','setBeSortBy','setBeFilter']),
			setupData(){
				this.resetBeFilter()
				this.resetBECart()
				get("CORE_HOTEL","room-type-rate",{
					reference_type: this.$route.params.type,
					reference_id: this.$route.params.id
				}).then(response=>{
					let res = response.data
					let self = this
					if(res.success){
						let params = {
							type: this.$route.params.type,
							data: res.data
						}
						this.setBeFilterDetail(params)
						this.setBeSortBy(this.$route.params.sort_by)
						this.getDetailData()
					}else{
						this.not_found = true
						setTimeout(() =>{
							self.$router.push({
								name : 'BERoom'
							})
						},3000)
					}
				})
			},
			getDetailData(){
				let module = this.$route.params.type.replace("_","-")
				get("CORE_HOTEL",module+"/"+this.$route.params.id).then(response=>{
					let res = response.data
					if(res.success){
            const date = this.setStayDate(res.data.min_nights);
            const guest = this.setGuest(res.data.guest_included);
            
						let params = {
							date,
							guest,
							promo_code: ''
						}
						this.setBeFilter(params)
					}
					let self = this
					setTimeout(() =>{
						self.$router.push({
							name : 'BERoom'
						})
					},300)
				})
			},
      setStayDate(defaultMinNights){
        const defaultStayDate = {
          check_in: moment().format("YYYY-MM-DD"),
          check_out: moment().add(defaultMinNights,'d').format("YYYY-MM-DD"),
        };
        const { check_in = null, total_night = null } = this.$route.query;
        if(this.$isEmpty(check_in) && this.$isEmpty(total_night)) return defaultStayDate;

        const isCheckinValid = moment(check_in, "YYYY-MM-DD", true).isValid();
        if(!isCheckinValid) return defaultStayDate;

        return {
          check_in: moment().format(check_in, "YYYY-MM-DD"),
          check_out: moment().add(Number(total_night),'d').format("YYYY-MM-DD"),
        }
      },
      setGuest(defaultGuestIncluded){
        const { adult = null, child = null, infant = null } = this.$route.query;
        return {
          adult: this.$isEmpty(adult) ? defaultGuestIncluded : Number(adult),
          child: this.$isNotEmptyV2(child) ? Number(child) : 0,
          infant: this.$isNotEmptyV2(infant) ? Number(infant) : 0,
        };
      }
		}
	}
</script>


// WEBPACK FOOTER //
// src/pages/hotel/be/BeDirectDetail.vue